import React from 'react';

const Privacy: React.FC = () => {
  return (
    <section className="privacy-section w-full px-6 md:px-12 lg:px-20 py-16 md:py-24">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Left Side - Content */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Block trackers, cookies, cookie consent popups and more.
          </h2>
          <div className="space-y-4 text-white/90 text-base">
            <p>Take back control of your privacy.</p>
            <p>Browse the web freely without tracking cookies or trackers slowing you down.</p>
          </div>
        </div>

        {/* Right Side - Meditating Person with Laptop */}
        <div className="relative">
          <div className="relative">
            <img 
              src="/images/person.png" 
              alt="Person meditating with laptop" 
              className="w-full h-auto object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacy;

